export default __webpack_public_path__ + "static/media/img-history-1.ec6801ef.png";